import { UnlockCompletePayload } from '@chegg-wt/core/state/modals/types'
import { AppRoute, AppRouteOpts } from '@chegg-wt/core/types/core'
import { AuthPayload } from '@chegg-wt/core/types/auth'
import { AuthModalOrigin } from '../AuthModal/types'

export enum TitleIconFilenames {
  SAVE = 'save-disk.svg',
  CITE = 'citations.svg',
  LOCK = 'lock.svg',
}

export enum Titles {
  CREATE_ACCOUNT_STYLE = 'Create a free account to use this style',
  CREATE_ACCOUNT_CITATIONS = 'Create a free account to save your citations',
  KEEP_CITING = 'Keep citing uninterrupted',
}

export enum ButtonTexts {
  CREATE_ACCOUNT = 'Create account',
  CREATE_FREE_ACCOUNT = 'Create free account',
}

export enum UnlockLinkMessages {
  WATCH_PAID = 'Watch a paid message instead',
}

export enum UnlockCompleteActions {
  FORM_SUBMIT = 'form-submit',
}

export interface UnlockLinkProps {
  message: UnlockLinkMessages
  completionAction: UnlockCompleteActions
  alwaysParticipate?: boolean
}

type AuthOrigin = AuthModalOrigin

export interface UnlockAccountGateModalData {
  origin: AuthOrigin
  titleIconFilename: TitleIconFilenames
  titleText: Titles
  createAccountButtonText: ButtonTexts
  canClose?: boolean
  fullMobileModal?: boolean
  maxWidth?: string
  unlock?: UnlockLinkProps
  shouldRedirectAuth?: boolean
  redirectRoute?: AppRoute
}

export interface UnlockAccountGateModalProps {
  closeModal: (name: string) => void
  modalData: UnlockAccountGateModalData
  unlockActivityCompleted?: (payload: UnlockCompletePayload) => void
  userClickClose: (origin: AuthOrigin) => void
  userClickLogin: (origin: AuthOrigin) => void
  userClickCreateAccount: (origin: AuthOrigin) => void
  userClickUnlock: () => void
  navigated: (appRoute: AppRoute, opts?: AppRouteOpts) => void
  formSubmitStopped: () => void
  onVideoReady: () => void
  startAuthFlow: (payload: AuthPayload) => void
}
